<template>
  <header class="zlc-header">
    <div class="zlc-header-left">
      <div class="zlc-location"><i class="el-icon-s-home"></i><span>企业管理端</span><i class="el-icon-arrow-right"></i><strong>{{menu_title}}</strong></div>
      <div class="zlc-header-tabs" v-if="tabList.length">
        <el-tabs v-model="activeValue" @tab-click="tabClick"><el-tab-pane v-for="(item,index) in tabList" :key="index" :label="item.value" :name="item.key"></el-tab-pane></el-tabs>
      </div>
    </div>
    <div class="zlc-header-right">
      <span class="zlc-environment"><span class="zlc-live-dot"></span> 安全生产管理</span>
      <span v-if="baseInfo.version && baseInfo.version.version" class="zlc-version">v{{baseInfo.version.version}}</span>
      <div class="zlc-divider"></div>
      <el-dropdown trigger="click" @command="handleCommand">
        <div class="zlc-user"><span class="zlc-avatar"><i class="el-icon-user-solid"></i></span><span class="zlc-user-name">{{(baseInfo.user && baseInfo.user.user_name) || '管理员'}}</span><i class="el-icon-arrow-down"></i></div>
        <el-dropdown-menu slot="dropdown"><el-dropdown-item command="password"><i class="el-icon-lock"></i> 修改密码</el-dropdown-item><el-dropdown-item command="refresh"><i class="el-icon-refresh"></i> 刷新权限</el-dropdown-item><el-dropdown-item divided command="logout"><i class="el-icon-switch-button"></i> 退出登录</el-dropdown-item></el-dropdown-menu>
      </el-dropdown>
    </div>
    <UpdatePassword v-if="is_password" @close="is_password=false"></UpdatePassword>
  </header>
</template>
<script>
import bus from '@/utils/eventBus.js';
import UserApi from '@/api/user.js';
import {delCookie,deleteSessionStorage} from '@/utils/base.js';
import UpdatePassword from './part/UpdatePassword.vue';
export default {
  components:{UpdatePassword}, inject:['baseInfo'],
  data(){return {menu_title:'工作台',tabList:[],activeValue:'',tab_type:'',is_password:false};},
  created(){bus.$on('menuName',this.setMenu);bus.$on('tabData',this.setTabs);this.$nextTick(()=>bus.$emit('headLoad',true));},
  beforeDestroy(){bus.$off('menuName',this.setMenu);bus.$off('tabData',this.setTabs);},
  methods:{
    setMenu(name){this.menu_title=name || '工作台';},
    setTabs(payload){this.tabList=payload && payload.list || [];this.activeValue=payload && payload.active != null ? payload.active : '';this.tab_type=payload && payload.tab_type || '';},
    tabClick(){bus.$emit('activeValue',this.activeValue);},
    handleCommand(command){if(command==='password') this.is_password=true;else if(command==='refresh') this.refreshPermissions();else if(command==='logout') this.login_out();},
    refreshPermissions(){
      deleteSessionStorage('rolelist');deleteSessionStorage('authlist');
      this.$message.success('权限已刷新，请稍候');
      window.location.reload();
    },
    login_out(){
      this.$confirm('确定退出智联车途管理平台吗？','退出登录',{confirmButtonText:'确定',cancelButtonText:'取消',type:'warning'}).then(()=>{
        UserApi.loginOut({},true).then(()=>{
          delCookie('isLogin');delCookie('token');delCookie('baseInfo');
          deleteSessionStorage('rolelist');deleteSessionStorage('authlist');
          this.$store.commit('user/setState',{key:'roles',val:null});
          this.$router.replace('/login');window.location.reload();
        }).catch(()=>this.$message.error('退出失败，请重试'));
      }).catch(()=>{});
    }
  }
};
</script>
<style scoped>
.zlc-header{height:72px;min-height:72px;display:flex;align-items:center;justify-content:space-between;padding:0 27px;background:#fff;box-shadow:0 3px 17px rgba(28,66,119,.045);border-bottom:1px solid #e8edf5;z-index:3}.zlc-header-left{display:flex;align-items:center;min-width:0;gap:25px}.zlc-location{display:flex;gap:12px;align-items:center;font-size:13px;color:#8a98ad;white-space:nowrap}.zlc-location>i:first-child{color:#3a73cc;font-size:17px}.zlc-location>i:nth-of-type(2){font-size:11px;color:#b6c0ce}.zlc-location strong{font-size:16px;font-weight:600;color:#1d3457}.zlc-header-right{display:flex;align-items:center;gap:18px}.zlc-environment{font-size:12px;color:#39725b;background:#eaf7f1;padding:8px 12px;border-radius:30px}.zlc-live-dot{display:inline-block;width:7px;height:7px;background:#22ad75;border-radius:50%;margin-right:6px}.zlc-version{font-size:12px;color:#9caabd}.zlc-divider{height:24px;border-left:1px solid #e5eaf1}.zlc-user{cursor:pointer;display:flex;gap:9px;align-items:center;color:#51647d}.zlc-avatar{height:33px;width:33px;display:flex;align-items:center;justify-content:center;background:#ecf3ff;color:#306dcc;border-radius:50%;font-size:16px}.zlc-user-name{font-size:13px;font-weight:600;color:#203b5b}.zlc-user>i:last-child{font-size:10px;color:#9bacc1}.zlc-header-tabs{max-width:460px;overflow:hidden}.zlc-header-tabs /deep/ .el-tabs__header{margin:0}.zlc-header-tabs /deep/ .el-tabs__nav-wrap::after{display:none}
</style>



// WEBPACK FOOTER //
// src/views/layout/Head.vue